<template>
  <div class="layer localinfoPreview" style="display: flex;">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle">{{locale.localinfo_preview}}</h2>
      <div>
        <Preview v-if="location"
          :colors="setting.colors"
          :site="setting.site"
          :skin="skin"
          :content="{ from: from, location: location }">
          <template v-slot:previewContent>
            <div class="localinfoLocation">
              <Map
                :from="from"
                :location="location" />
            </div>
            <div class="localinfoBox">
              <div class="localDetail">
                <!-- name -->
                <p class="name"><img :src="location.icon" />{{location.name}}</p>
                <!-- //name -->
                <!-- distance -->
                <p class="long">
                  <span class="distance">{{distance}}</span>
                  <span class="walking">{{onfoot}}</span>
                </p>
                <!-- //distance -->
                <!-- rating -->
                <div class="rating">
                  <span class="rate">{{`${!!location.rating ? location.rating : 0} / 5`}}</span>
                  <div class="ratingStar">
                    <span class="star"></span>
                    <span class="bar" :style="rating(location.rating)"></span>
                  </div>
                  <span v-if="!!location.user_ratings_total" class="ratedUser">{{`(${location.user_ratings_total})`}}</span>
                </div>
                <!-- //rating -->
                <!-- photos -->
                <div v-if="!!location.sitePhotos && location.sitePhotos.length" class="carousel">
                  <Carousel
                    :loop="true"
                    :perPage="1"
                    :mouseDrag="true"
                    :paginationPadding="4"
                    :paginationActiveColor="'rgba(0,0,0,0.4)'"
                    :paginationColor="'rgba(0,0,0,0.2)'">
                    <Slide v-for="(img, index) in location.sitePhotos" :key="index">
                      <img :src="`https://google-map-photos.s3.ap-northeast-2.amazonaws.com/${img}`" alt="" />
                    </Slide>
                  </Carousel>
                </div>
                <!-- //photos -->
                <!-- review -->
                <div v-if="!!location.reviews && location.reviews.length" class="review mt10">
                  <div
                    v-for="(review, index) in location.reviews"
                    :key="index" class="item mt15">
                    <div class="reviewer">
                      <div class="thumb"><img :src="review.profile_photo_url"></div>
                      <span class="user">{{review.author_name}}</span>
                      <div class="star">
                        <span v-for="star in 5" :key="star" :class="{on: star < review.rating + 1}">&#9733;</span>
                        <span class="time">{{review.relative_time_description}}</span>
                      </div>
                    </div>
                    <div class="context mt5"
                      :class="{more: review.isOpen}"
                      @click.stop="toggleReview($event)">
                      {{review.text}}
                    </div>
                  </div>
                </div>
                <!-- //review -->
                <!-- place info -->
                <div class="place">
                  <!-- tel -->
                  <p v-if="!!location.formatted_phone_number" class="tel"><a :href="`tel:${location.international_phone_number}`">{{location.formatted_phone_number}}</a></p>
                  <!-- address -->
                  <p v-if="location.formatted_address" class="address mt10">{{location.formatted_address}}</p>
                </div>
                <!-- //place info -->
              </div>
            </div>
          </template>
        </Preview>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import Map from '@/components/LocalInfo/LocalInfoMap.vue'
import Preview from '@/components/Util/Preview.vue'
import { Carousel, Slide } from 'vue-carousel'

export default {
  props: [
    'locale',
    'from',
    'location'
  ],
  components: {
    Map,
    Preview,
    Carousel,
    Slide
  },
  computed: {
    skin () {
      return this.$store.state.setting.skin
    },
    setting () {
      return {
        colors: this.$store.state.setting.colors,
        site: this.$store.state.setting.site
      }
    },
    distance () {
      const distance = this.location.distance
      const d = distance >= 1000 ? distance / 1000 : distance
      const unit = distance >= 1000 ? 'km' : 'm'
      return `${this.locale.localinfo_fromhotel} ${regExp.comma(d)}${unit}`
    },
    onfoot () {
      const secPerDistance = Math.floor(this.location.distance * 0.9) // sec per distance :: 1분에 66.6m -> 1m당 0.9초
      const LOCALE = this.locale
      function minSec (seconds) {
        const hour = parseInt(seconds / 3600)
        const min = parseInt((seconds % 3600) / 60)
        // const sec = seconds % 60
        let message = `${LOCALE.localinfo_onfoot} `
        if (seconds <= 60) {
          message += LOCALE.within1min
        } else {
          if (hour >= 1) {
            message += `${LOCALE.time_about} ${hour}${LOCALE.hour}`
          }
          if (min >= 1) {
            message += `${LOCALE.time_about} ${min}${LOCALE.minute}`
          }
          // if (sec >= 1) {
          //   message = message += ` ${sec}${LOCALE.seconds}`
          // }
        }
        return message
      }
      return minSec(secPerDistance)
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    toggleReview (e) {
      const toggle = e.currentTarget.className.includes('more') ? 'remove' : 'add'
      e.currentTarget.classList[toggle]('more')
    },
    rating (rating) {
      const rate = !!rating ? rating : 0
      const percent = Math.floor(rate / 5 * 100)
      return {
        width: `${percent}%`
      }
    }
  }
}
</script>
